import {
  SLIDE_THREE_DRAG_DROP,
  SLIDE_THREE_REMOVE_DROP,
  SLIDE_THREE_SET_AS_NEXT_STEP,
  SLIDE_THREE_APPLY_HINT,
} from '../../Redux.constants';

import {
  slideThreeDragDrop,
  slideThreeRemoveDrop,
  slideThreeSetAsNextStep,
  slideThreeApplyHint,
} from './helper';

export function SlideThreeReducer(state = {}, action) {
  switch (action.type) {
    case SLIDE_THREE_DRAG_DROP:
      return slideThreeDragDrop(state, action.payload);
    case SLIDE_THREE_REMOVE_DROP:
      return slideThreeRemoveDrop(state, action.payload);
    case SLIDE_THREE_SET_AS_NEXT_STEP:
      return slideThreeSetAsNextStep(state, action.payload);
    case SLIDE_THREE_APPLY_HINT:
      return slideThreeApplyHint(state, action.payload);
    default:
      return state;
  }
}
